import type { IFilterQuery } from '@shared';
import type { IAdsType, IAdsTypePageableResponseData } from '@shared/ads-type';

const ENDPOINT_PREFIX = 'ads-type';

export const useAdsTypeStore = defineStore('ads-type', () => {
  const apiClient = useApiClient();
  const adsTypes = ref<IAdsType[]>([]);
  const { setItem, getItem } = useLocalStorage();
  const adsType = ref<IAdsType | null>(null);

  const filter = async (payload?: IFilterQuery) => {
    if (!payload) payload = { page: 1, limit: 1000 };
    const result = await apiClient.post<
      IFilterQuery,
      IAdsTypePageableResponseData
    >(ENDPOINT_PREFIX + '/filter', payload);
    if (result.success) adsTypes.value = result.data?.data as IAdsType[];
    return result;
  };

  const setAdsType = (type: IAdsType) => {
    setItem('adsType', type);
    adsType.value = type;
    return type;
  };

  const initAdsType = () => {
    adsType.value = getItem('adsType');
  };

  const clearTypes = () => {
    adsTypes.value = [];
  }

  return {
      filter,
      adsTypes,
      adsType,
      setAdsType,
      initAdsType,
      clearTypes,
  }
})
